import { LoadingButton } from "@mui/lab";
import {
  Button,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteSmsServiceProviderThunk } from "store/reducers/third_party/smsProviderSlice";

const SmsProviderItem = ({ item,handleEditClick }) => {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.smsProvider);
  const deleteItem = (item) => {
    dispatch(deleteSmsServiceProviderThunk(item.id));
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <TableRow
        key={item.id}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell align="left" component="th" scope="row">
          {item.id}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {item.name}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {item.code}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {item.credential_format ? <Button variant="text" onClick={(e) => {
              handleClick(e);
            }}>View</Button> : "-"}
        </TableCell>

        <TableCell align="center" component="th" scope="row">
          <Button
            variant="outlined"
            sx={{ width: "10ch" }}
            color="info"
            onClick={(e) => {
            handleEditClick(item)
            }}
          >
            Edit
          </Button>
        </TableCell>

        <TableCell align="right" component="th" scope="row">
          <LoadingButton
            variant="outlined"
            sx={{ width: "10ch" }}
            color="error"
            onClick={() => {
              deleteItem(item);
            }}
            loading={status?.loading === "delete" && status?.id === item.id}
          >
            Delete
          </LoadingButton>
        </TableCell>
      </TableRow>
      {item.credential_format && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Name</TableCell>
                <TableCell align="center">Type</TableCell>
                <TableCell align="right">Required</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {item.credential_format.map((cred, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell align="left" component="th" scope="row">
                    {cred.name}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {cred.type}
                  </TableCell>
                  <TableCell align="right" component="th" scope="row">
                    {cred.required ? "Yes" : "No"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Popover>
      )}
    </>
  );
};

export default SmsProviderItem;
